<script>


</script>

<header>
    <h1> <img src="Img/Image.png" alt="Icon"></h1>

</header>

<style>
h1 {
    font-size: 2rem;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin: 0;
}
img {
    width: 170px;
    height: auto;
    max-height: 170px;
    object-fit: contain;
}
header {
    background-color: #fdfdfd;
    padding: 10px 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
}
</style>